import { render, staticRenderFns } from "./PdfFile.vue?vue&type=template&id=7c9559c0&scoped=true&lang=pug"
import script from "./PdfFile.vue?vue&type=script&lang=js"
export * from "./PdfFile.vue?vue&type=script&lang=js"
import style0 from "./PdfFile.vue?vue&type=style&index=0&id=7c9559c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9559c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
